<template>
  <WrapWithHint class="control" :content="hintText">
    <div @click="onWrapperClick">
      <button class="button text-hidden-mobile" :class="buttonClasses" @click="openModal">
        <span class="icon">
          <i class="fad fa-peanuts"></i>
        </span>
        <span>Facility Allergens</span>
      </button>
    </div>
  </WrapWithHint>
</template>

<script setup>import { computed as _computed } from 'vue';

  import WrapWithHint from "../wrap-with-hint.vue";
  import { Modal } from "~/jose_modern/modal";

  const props = defineProps({
    selectedIds: { type: Array, required: true },
    count: { type: Number, required: true },
    hintEventName: { type: String, default: null },
  });

  const hintText = _computed(() =>
    props.count === 0 ? "Select recipes to set facility allergens" : null
  );

  const buttonClasses = _computed(() =>
    props.count > 0 ? ["is-outlined", "is-info"] : ["is-outlined", "click-disabled"]
  );

  function openModal() {
    if (props.count === 0) return;
    const modal = document.getElementById("facility-allergens-modal");
    if (modal) modal.dataset.selectedRecipeIds = props.selectedIds.join(",");
    Modal.show("#facility-allergens-modal");
  }

  function onWrapperClick() {
    if (props.count === 0 && props.hintEventName) {
      document.dispatchEvent(new CustomEvent(props.hintEventName));
    }
  }
</script>
